import { updateStateValue, getStateValue } from "~/utils";
import { USER_PATHS } from "~/utils/constants";

/**
 * Add club from the user state.
 */
export const clubConsent = (): void => {
  updateStateValue("service", true);
  updateStateValue("servicePack", CLUB_PLATINUM.code);
  updateStateValue("serviceAmount", CLUB_PLATINUM.value / 12);
};

/**
 * Removes club from the user state.
 */
export const clubDecline = (): void => {
  updateStateValue("service", false);
  updateStateValue("clubConsentMain", null);
  updateStateValue("clubConsent1", null);
  updateStateValue("clubConsent2", null);
  updateStateValue("clubConsent3", null);
  updateStateValue("clubConsent4", null);
};

/**
 * Checks if Club Plus membership is available for the user based on age.
 */
export const clubPlusAvailable = () => {
  const AGE = userAge();
  return AGE >= 18 && AGE < 74;
};

/**
 * Removes club plus from the user state.
 */
export const clubPlusDecline = (): void => {
  updateStateValue("service", false);
  updateStateValue("clubPlusConsent1", null);
  updateStateValue("clubPlusConsent2", null);
  updateStateValue("clubPlusConsent3", null);
  updateStateValue("clubPlusConsent4", null);
  updateStateValue("clubPlusConsent5", null);
  updateStateValue("clubPlusConsent5a", null);
  updateStateValue("clubPlusConsent5b", null);
  updateStateValue("clubPlusConsent5c", null);
  updateStateValue("clubPlusConsent5d", null);
};

/**
 * Add club from the user state.
 */
export const clubLightConsent = (): void => {
  updateStateValue("service", true);
  updateStateValue("servicePack", "CLLGT");
  updateStateValue("serviceAmount", 0);
};

/**
 * Removes club light from the user state.
 */
export const clubLightDecline = (): void => {
  updateStateValue("service", false);
  updateStateValue("clubLightConsentMain", null);
  updateStateValue("clubLightConsent1", null);
  updateStateValue("clubLightConsent2", null);
  updateStateValue("clubLightConsent3", null);
  updateStateValue("clubLightConsent4", null);
};

/**
 * Verify if the user is eligible for subscription to the club.
 */
export const hasService = () => {
  return getStateValue("service", null);
};

/**
 * Verify if CyberWeby is available according to selected credit
 */
export const cyberWebyAvailable = (): boolean => {
  const fido = getModel(getStateValue("credit")).fido;
  const isFE: boolean = userPath && userPath() === USER_PATHS.FE;
  if (!fido) return false;
  return isFE && isRevolving() && fido !== getStateValue("credit");
}

/**
 * Verify if Sovendus widget is available
 */
export const sovendusAvailable = (): boolean => {
  return userPath && userPath() !== USER_PATHS.FE;
}